import Button from '../Button';
import { getQTipData } from '../Tooltip/qTip.utilities';
import type { ButtonGroupProps } from './ButtonGroup.types';

const baseClasses = 'tw:flex tw:outline-none tw:w-full tw:relative tw:flex-wrap';

const activeClassesByVariantLightTheme = {
  'outline': 'tw:bg-sq-disabled-gray tw:border-sq-theme-dark',
  'theme': 'tw:bg-sq-theme-highlight',
  'danger': '',
  'theme-light': '',
  'no-border': 'tw:bg-sq-disabled-gray!',
  'warning': '',
};

const activeClassesByVariantDarkTheme = {
  'outline': 'tw:dark:bg-sq-multi-gray-dark tw:dark:border-sq-theme-dark',
  'theme': 'tw:dark:bg-sq-theme-highlight',
  'danger': '',
  'theme-light': '',
  'no-border': 'tw:dark:bg-sq-multi-gray-dark!',
  'warning': '',
};
/**
 * ButtonGroup.
 */
export const ButtonGroup = (props: ButtonGroupProps) => {
  const { id, extraClassNames = '', testId, onChange, buttons = [], ...tooltipProps } = props;
  const tooltipData = getQTipData(tooltipProps);

  const appliedClasses = `${baseClasses} ${extraClassNames}`;

  return (
    <div id={id ? `button-group-${id}` : undefined} data-testid={testId} className={appliedClasses} {...tooltipData}>
      {buttons.filter(Boolean).map((item, index) => {
        if (item?.variant === 'button') {
          const { isActive, ...buttonPropsWithoutIsActive } = item.buttonProps;
          return (
            <Button
              key={index}
              {...buttonPropsWithoutIsActive}
              extraClassNames={`tw:-ml-sq-1 tw:focus:z-40 tw:outline-none tw:focus:border tw:rounded-none tw:first:rounded-l-md tw:last:rounded-r-md ${
                isActive
                  ? `${activeClassesByVariantLightTheme[item.buttonProps.variant ?? 'outline']} ${
                      activeClassesByVariantDarkTheme[item.buttonProps.variant ?? 'outline']
                    } `
                  : ''
              } ${item.buttonProps.extraClassNames}`}
              onClick={() => onChange && onChange(item.buttonProps.value)}
            />
          );
        }
        return item?.element;
      })}
    </div>
  );
};
